var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"translate-item"},[_c('button',{staticClass:"translate-choice",on:{"click":_vm.setLanguage}},[_c('base-font',{staticClass:"translate-lang notranslate",class:{active: _vm.activeLang.toLowerCase() === _vm.country.toLowerCase()}},[_vm._v(_vm._s(_vm.country.toUpperCase()))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }